//src/components/services/index.js
import React from 'react';

const ServiceTabs = ({ activeTab, onTabChange }) => {
  return (
    <div className="flex mb-8 rounded-full overflow-hidden shadow-md">
      <button 
        onClick={() => onTabChange('full')}
        className={`flex-1 py-3 px-6 transition-all duration-200 ${
          activeTab === 'full' 
            ? 'bg-blue-500 text-white font-medium'
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        }`}
      >
        Full Detail
      </button>
      <button 
        onClick={() => onTabChange('exterior')}
        className={`flex-1 py-3 px-6 transition-all duration-200 ${
          activeTab === 'exterior' 
            ? 'bg-blue-500 text-white font-medium'
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        }`}
      >
        Exterior Only
      </button>
      <button 
        onClick={() => onTabChange('interior')}
        className={`flex-1 py-3 px-6 transition-all duration-200 ${
          activeTab === 'interior' 
            ? 'bg-blue-500 text-white font-medium'
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        }`}
      >
        Interior Only
      </button>
    </div>
  );
};

export default ServiceTabs;